import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import logo from '../assets/logo.PNG';
import '../views/style.css'

function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();

  // Effet de scroll pour le changement de style
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 10) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Fermer le menu mobile quand on change de page
  useEffect(() => {
    setIsOpen(false);
  }, [location]);

  return (
    <nav className={`navbar ${scrolled ? 'navbar-scrolled' : 'navbar-default'}`}>
      <div className="navbar-container">
        {/* Logo */}
        <Link to="/">
          <div className="logo-container">
            <span className="logo-text">TechStride Consulting</span>
          </div>
        </Link>


        {/* Navigation principale - Desktop */}
        <div className="desktop-menu">
          {[
            { path: '/', label: 'Home' },
            { path: '/services', label: 'Services' },
            { path: '/activities', label: 'Activities' },
            { path: '/contact', label: 'Contact us' },
            { path: '/about', label: 'About us' },
          ].map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={`nav-link ${location.pathname === item.path ? 'nav-link-active' : ''}`}
            >
              {item.label}
            </Link>
          ))}
          <Link to="/jobs" className="jobs-button">
            Jobs
          </Link>
        </div>

        {/* Bouton menu - Mobile */}
        <button
          onClick={() => setIsOpen(!isOpen)}
          className="mobile-menu-button"
          aria-label="Menu"
        >
          <svg
            className="w-6 h-6 text-gray-700"
            width="24"
            height="24"
            fill="none"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            {isOpen ? (
              <path d="M6 18L18 6M6 6l12 12"></path>
            ) : (
              <path d="M4 6h16M4 12h16M4 18h16"></path>
            )}
          </svg>
        </button>
      </div>

      {/* Menu mobile */}
      <div className={`mobile-menu ${isOpen ? 'mobile-menu-visible' : 'mobile-menu-hidden'}`}>
        <div className="mobile-menu-container">
          {[
            { path: '/', label: 'TechStride Consulting' },
            { path: '/services', label: 'Services' },
            { path: '/activities', label: 'Activities' },
            { path: '/contact', label: 'Contact us' },
          ].map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={`mobile-nav-link ${location.pathname === item.path ? 'mobile-nav-link-active' : ''
                }`}
            >
              {item.label}
            </Link>
          ))}
          <Link to="/jobs" className="mobile-jobs-button">
            Jobs
          </Link>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;